import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative rounded-lg flex flex-col justify-between overflow-hidden bg-primary-300/20 dark:bg-stone-600/60 p-0" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "relative z-10 p-6 sm:p-8" }
const _hoisted_4 = { class: "flex flex-col h-full" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_7 = ["src", "alt"]

import type { PropType } from "vue";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowCaseCard',
  props: {
  icon: {
    type: String,
    default: "i-heroicons-computer-desktop",
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    default: "#",
  },
  image: {
    type: String,
    required: true,
  },
  imagePosition: {
    type: String as PropType<"bottom" | "left" | "right" | "cover">,
    default: "bottom",
    validator: (value: string) => ["bottom", "left", "right", "cover"].includes(value),
  },
  color: {
    type: String,
    default: "stone",
  },
  colorShade: {
    type: String,
    default: "300",
  },
  darkColor: {
    type: String,
    default: null,
  },
  darkColorShade: {
    type: String,
    default: "900",
  },
  textColor: {
    type: String,
    default: "stone",
  },
  reverse: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const colorMode = useColorMode();
const props = __props;

const imageContainerClasses = computed(() => {
  const base = "relative overflow-hidden lg:min-h-[260px] p-0 border-box flex-1";
  switch (props.imagePosition) {
    case "left":
      return `${base} flex items-end justify-start`;
    case "right":
      return `${base} flex items-end justify-end`;
    case "bottom":
      return `${base} flex items-end justify-end`;
    default:
      return `${base} flex items-end justify-center`;
  }
});

const imageClasses = computed(() => {
  const base = "max-h-full p-0";
  switch (props.imagePosition) {
    case "left":
      return `${base} absolute bottom-0 left-0 h-full w-full object-contain object-left rounded-t-2xl`;
    case "right":
      return `${base} absolute bottom-0 right-0 h-full w-full object-contain object-right`;
    case "bottom":
      return `${base} absolute bottom-0 right-0 w-full h-full object-contain object-cover`;
    default:
      return `${base} relative w-full h-full object-contain object-bottom rounded-t-2xl`;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UButton = _resolveComponent("UButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.imagePosition === 'cover')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.image,
          alt: __props.title,
          class: "absolute inset-0 w-full h-full object-cover"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_UIcon, {
              name: __props.icon,
              class: _normalizeClass([
                `text-base ${props.reverse ? 'text-white' : `text-${props.textColor}-600 dark:text-${props.textColor}-300`}`,
              ])
            }, null, 8, ["name", "class"]),
            _createElementVNode("p", {
              class: _normalizeClass([
                `font-semibold text-sm ${props.reverse ? 'text-white' : `text-${props.textColor}-700 dark:text-${props.textColor}-300`}`,
              ])
            }, _toDisplayString(__props.title), 3)
          ]),
          _createElementVNode("p", {
            class: _normalizeClass([
              `text-xl font-bold ${props.reverse ? 'text-white' : `text-${props.textColor}-900 dark:text-white`}`,
            ])
          }, _toDisplayString(__props.description), 3)
        ]),
        _createVNode(_component_UButton, {
          icon: "i-heroicons-chevron-right-20-solid",
          color: "white",
          variant: "solid",
          "aria-label": __props.title,
          to: __props.link,
          class: "absolute top-6 right-6 rounded-md transition-transform duration-200 ease-in-out hover:scale-110 hover:rotate-6 text-neutral-900",
          size: "xl"
        }, null, 8, ["aria-label", "to"])
      ])
    ]),
    (__props.imagePosition !== 'cover')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(imageContainerClasses.value)
        }, [
          _createElementVNode("img", {
            src: __props.image,
            alt: __props.title,
            class: _normalizeClass(imageClasses.value)
          }, null, 10, _hoisted_7)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})